import { createAsyncThunk } from "@reduxjs/toolkit";
import { getData } from "../../utils/getData";

export const getInitiativeCounts = createAsyncThunk(
  "initiatives/getCounts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getData(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/counts`
      );
      if (!response || !response.success) {
        return rejectWithValue(response?.message || "Failed to fetch counts");
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch counts");
    }
  }
);
